"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function getParameterByName(name, url) {
    if (!url) {
        url = window.location.href;
    }
    name = name.replace(/[[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"), results = regex.exec(url);
    if (!results)
        return null;
    if (!results[2])
        return "";
    return decodeURIComponent(results[2].replace(/\+/g, " "));
}
exports.getParameterByName = getParameterByName;
function getIdsFromPathParams(path) {
    var results = path.trim().split("/");
    if (results.length <= 0)
        return "";
    if (results.length >= 0 && results.length <= 2)
        return "";
    if (results.length > 3)
        return "";
    var stringUserId = results[1], stringTaskUserId = results[2];
    var taskUserId = Number(stringTaskUserId.trim());
    var userId = Number(stringUserId.trim());
    var isTaskUserIdInteger = Number.isInteger(taskUserId);
    var isUserIdInteger = Number.isInteger(userId);
    if (!isTaskUserIdInteger && !isUserIdInteger) {
        return "";
    }
    return {
        taskUserId: taskUserId,
        userId: userId
    };
}
exports.getIdsFromPathParams = getIdsFromPathParams;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZ2V0UGFyYW1ldGVyQnlOYW1lLmpzIiwic291cmNlUm9vdCI6Ii4vIiwic291cmNlcyI6WyJwZGYvbGliL2Z1bmN0aW9ucy9nZXRQYXJhbWV0ZXJCeU5hbWUudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFBQSxTQUFnQixrQkFBa0IsQ0FBQyxJQUFJLEVBQUUsR0FBSTtJQUN6QyxJQUFJLENBQUMsR0FBRyxFQUFFO1FBQ04sR0FBRyxHQUFHLE1BQU0sQ0FBQyxRQUFRLENBQUMsSUFBSSxDQUFBO0tBQzdCO0lBRUQsSUFBSSxHQUFHLElBQUksQ0FBQyxPQUFPLENBQUMsUUFBUSxFQUFFLE1BQU0sQ0FBQyxDQUFBO0lBQ3JDLElBQUksS0FBSyxHQUFHLElBQUksTUFBTSxDQUFDLE1BQU0sR0FBRyxJQUFJLEdBQUcsbUJBQW1CLENBQUMsRUFDdkQsT0FBTyxHQUFHLEtBQUssQ0FBQyxJQUFJLENBQUMsR0FBRyxDQUFDLENBQUE7SUFDN0IsSUFBSSxDQUFDLE9BQU87UUFBRSxPQUFPLElBQUksQ0FBQTtJQUN6QixJQUFJLENBQUMsT0FBTyxDQUFDLENBQUMsQ0FBQztRQUFFLE9BQU8sRUFBRSxDQUFBO0lBQzFCLE9BQU8sa0JBQWtCLENBQUMsT0FBTyxDQUFDLENBQUMsQ0FBQyxDQUFDLE9BQU8sQ0FBQyxLQUFLLEVBQUUsR0FBRyxDQUFDLENBQUMsQ0FBQTtBQUM3RCxDQUFDO0FBWEQsZ0RBV0M7QUFFRCxTQUFnQixvQkFBb0IsQ0FBQyxJQUFJO0lBQ3JDLElBQU0sT0FBTyxHQUFHLElBQUksQ0FBQyxJQUFJLEVBQUUsQ0FBQyxLQUFLLENBQUMsR0FBRyxDQUFDLENBQUE7SUFDdEMsSUFBSSxPQUFPLENBQUMsTUFBTSxJQUFJLENBQUM7UUFBRSxPQUFPLEVBQUUsQ0FBQTtJQUNsQyxJQUFJLE9BQU8sQ0FBQyxNQUFNLElBQUksQ0FBQyxJQUFJLE9BQU8sQ0FBQyxNQUFNLElBQUksQ0FBQztRQUFFLE9BQU8sRUFBRSxDQUFBO0lBQ3pELElBQUksT0FBTyxDQUFDLE1BQU0sR0FBRyxDQUFDO1FBQUUsT0FBTyxFQUFFLENBQUE7SUFDeEIsSUFBQSx5QkFBWSxFQUFFLDZCQUFnQixDQUFXO0lBQ2xELElBQU0sVUFBVSxHQUFHLE1BQU0sQ0FBQyxnQkFBZ0IsQ0FBQyxJQUFJLEVBQUUsQ0FBQyxDQUFBO0lBQ2xELElBQU0sTUFBTSxHQUFHLE1BQU0sQ0FBQyxZQUFZLENBQUMsSUFBSSxFQUFFLENBQUMsQ0FBQTtJQUMxQyxJQUFNLG1CQUFtQixHQUFHLE1BQU0sQ0FBQyxTQUFTLENBQUMsVUFBVSxDQUFDLENBQUE7SUFDeEQsSUFBTSxlQUFlLEdBQUcsTUFBTSxDQUFDLFNBQVMsQ0FBQyxNQUFNLENBQUMsQ0FBQTtJQUNoRCxJQUFJLENBQUMsbUJBQW1CLElBQUksQ0FBQyxlQUFlLEVBQUU7UUFDMUMsT0FBTyxFQUFFLENBQUE7S0FDWjtJQUNELE9BQU87UUFDSCxVQUFVLFlBQUE7UUFDVixNQUFNLFFBQUE7S0FDVCxDQUFBO0FBQ0wsQ0FBQztBQWpCRCxvREFpQkMifQ==